'use client';

import { c as _c } from "react/compiler-runtime";
import { ApiErrors } from '@repo/features/error';
import { Button } from '@repo/ui/components';
import Link from 'next/link';
type CompanyTypeAlias = 'broker' | 'haulier' | 'other' | 'shipper';
const getManagementOverviewPath = ({
  alias,
  id
}: {
  alias: CompanyTypeAlias | null | undefined;
  id: number;
}) => {
  switch (alias) {
    case 'broker':
      return `/management/brokers/${id}/overview`;
    case 'haulier':
      return `/management/carriers/${id}/overview`;
    case 'shipper':
      return `/management/customers/${id}/overview`;
    default:
      return `/management/customers/${id}/overview`;
  }
};
type ExistingCompanyAlertProps = {
  allowedInsertTypes?: readonly CompanyTypeAlias[];
  company: {
    id: number;
    title: string;
    type?: null | {
      alias?: CompanyTypeAlias | null;
    };
  };
  onInsert: (() => void) | null;
};
export const ExistingCompanyAlert = t0 => {
  const $ = _c(14);
  const {
    allowedInsertTypes: t1,
    company,
    onInsert
  } = t0;
  const allowedInsertTypes = t1 === undefined ? ["shipper", "broker"] : t1;
  const companyTypeAlias = company.type?.alias;
  const canInsert = Boolean(companyTypeAlias && allowedInsertTypes.includes(companyTypeAlias));
  let t2;
  if ($[0] !== onInsert) {
    t2 = onInsert ? <Button onClick={onInsert} type="button" variant="outline">Insert</Button> : null;
    $[0] = onInsert;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== company.id || $[3] !== companyTypeAlias) {
    t3 = getManagementOverviewPath({
      alias: companyTypeAlias,
      id: company.id
    });
    $[2] = company.id;
    $[3] = companyTypeAlias;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== company.title || $[6] !== t3) {
    t4 = <Link className="font-medium underline" href={t3} target="_blank">{company.title}</Link>;
    $[5] = company.title;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = companyTypeAlias === "haulier" && !canInsert ? " It is a carrier company type and cannot be used as a customer." : canInsert ? ". Use Insert to select it instead of creating a duplicate." : null;
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = {
      message: <>This company already exists in our platform{" "}{t4}{t5}</>,
      title: "Company already exists"
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <ApiErrors action={t2} errors={t6} data-sentry-element="ApiErrors" data-sentry-component="ExistingCompanyAlert" data-sentry-source-file="existing-company-alert.tsx" />;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};